import CmsSlider from "../../componets/CmsSlider";
import brandsData from "../../data/printDesignAndServiceBrands.json";

export default function Section4() {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true, 
    slidesToShow: 3, 
    slidesToScroll: 1, 
    autoplay: true,
    speed: 300,
    autoplaySpeed: 3000,
  };

  return (
    <div className="Section4 pt-[75px] pb-[35px] bg-[#F5F5F5]">
      <div className="section4-container">
        <h2 className="leading-[29px] md:leading-[41px] text-center text-[24px] md:text-[34px] text-[#da2128] font-bold my-[0.67em]">
          Our Clients
        </h2>

        <div className="w-full py-[35px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]">
          <CmsSlider settings={settings} slides={brandsData} />
        </div>
      </div>
    </div>
  );
}
